/**
 * useAppInvite — POST /api/v1/invites/app mutation.
 *
 * Sends an email invite to a non-user. Endpoint returns 204 No
 * Content on success, so we hit apiFetch directly instead of
 * apiPost (which always parses JSON).
 */

import { useMutation } from '@tanstack/react-query'
import { apiFetch, HttpError } from '../lib/api'
import type { AppInviteRequest } from '@warcarp/api-types'

export function useAppInvite() {
  return useMutation({
    mutationFn: async (input: AppInviteRequest) => {
      const res = await apiFetch('/api/v1/invites/app', {
        method: 'POST',
        body: JSON.stringify(input),
      })
      if (!res.ok) {
        const err = (await res.json().catch(() => ({}))) as {
          message?: string
          error?: string
        }
        throw new HttpError(
          res.status,
          err.message ?? err.error ?? `HTTP ${res.status}`,
        )
      }
      // 204 No Content — nothing to parse, nothing to return.
    },
  })
}
